module.exports = __webpack_public_path__ + "static/media/micr-e13b.59fbd66e.ttf";